module.exports = __webpack_public_path__ + "static/media/excelfile.26638d0e.svg";